<template>
  <div class="sheetCostListPage">
    <div class="bg">
      <div class="content-box">
        <div class="top-content">
          <el-dropdown class="dropdown" trigger="click" @command="selectTimeRangeCommand">
            <el-button class="select-btn" :style="{color: '#565656'}" @click="pushRfc">
              {{ curTimeRange.title }}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <template #dropdown>
              <el-dropdown-menu class="dropdown-list">
                <el-dropdown-item
                  v-for="(timeRange, index) in timeRangeList"
                  class="dropdown-item"
                  :command="index"
                  :key="index"
                  :style="{color: getCurrentTimeColor(timeRange.title)}"
                >{{ timeRange.title }}</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <!-- <el-dropdown class="dropdown" trigger="click" @command="selectUserNameCommand">
            <el-button class="select-btn" :style="{color: '#565656'}" @click="pushRfc">
              {{ curUserName }}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  v-for="(userName, index) in userNameList"
                  class="dropdown-item"
                  :command="index"
                  :key="index"
                  :style="{color: getCurrentNameColor(userName)}"
                >{{ userName }}</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown> -->
        </div>
        <el-table class="table" ref="dragTable" :data="dataList" v-loading="loading"
          element-loading-background="rgba(255, 255, 255, 0.8)" border width="100%" fit 
          :header-cell-style="{
            background: '#ECF2FE',
            borderColor: '#999999',
          }" 
          :cell-style="{
            borderColor: '#999999',
          }">
          <el-table-column fixed :width="520" align="center">
            <template #header>
              <div class="header-title">{{ headerTitle }}</div>
            </template>
            <template #default="scope">
              <div class="trial-bg">
                <div class="table-trial" @click="pushTrialList(scope.row)">
                  {{ scope.row.trail }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column align="center" v-for="headerItem in headerTitleList" :key="headerItem">
            <template #header>
              <div class="header-title" @click="sortDo(headerItem.title)">{{ headerItem.title }}</div>
            </template>
            <template #default="scope">
              <div class="table-other">
                {{
                  getItemValue(scope.row, headerItem)
                }}
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="page-cost">
          Sum: <span>{{ totalPrice }}</span> (￥)
        </div>
        <div class="page-bg">
          <div class="page-left">共 {{ totalCount }} 项数据</div>
          <el-pagination class="page-right" background layout="prev, pager, next" :total="totalCount" :page-size="pageSie"
            :current-page="currentPage" @current-change="currentDo">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { queryResourcesList, getQueryMetricsBySheet } from "@/request/api";
import { BenchMarkType, getCostValueByRun, pushToNewWindowByParams, TimeRangeDataList } from "@/utils/common"
import {
  ResourceType,
  TimeUnit
} from "@/ginkgo-grpc/jslang/proto/services/rbf_service_pb";
import moment from "moment";
export default {
  name: "sheetCostListPage",
  data() {
    return {
      allDataList: [],
      originAllDataList: [],
      headerTitle: "",
      headerTitleList: [
        {
          title: "CREATEDAT",
          value: "createDate",
        },
        {
          title: "OWNER",
          value: "owner",
        },
        {
          title: "PRICE(￥)",
          value: "cost",
        },
      ],
      currentPage: 1,
      pageSie: 5,
      selectTags: [],
      resourceType: ResourceType.SHEET,
      loading: true,
      // totalCount: 0,
      filterList: [],
      allTrialList: [],
      curTimeRange: {
        title: "24Hours",
        value: TimeUnit.DAY,
        length: 1,
      },
      timeRangeList: TimeRangeDataList,
      curUserName: 'None',
      userNameList:[],
      totalPrice: 0,
      selectHeaderTitle: '',
      isUpperClick: false,
    };
  },
  components: {
  },
  computed: {
    selectUserName() {
      return this.curUserName == 'None' ? '': this.curUserName
    },
    totalCount() {
      return this.allDataList?.length
    },
    dataList() {
      const list = this.allDataList.slice((this.currentPage - 1) * this.pageSie, this.currentPage * this.pageSie)
      return list;
    }
  },
  methods: {
    getItemValue(model, headerItem) {
      if (headerItem.value == "cost") {
        const value = model[headerItem.value]
        return Math.round(value * 100) / 100
      }
      return model[headerItem.value] ? model[headerItem.value] : '/'
    },
    pushTrialList(item) {
      console.log("pushTrialList == ", item);
      pushToNewWindowByParams("TrialCostListPage", {id: item.resourceId, userId: item.committer})
    },
    sortDo(title) {
      if (this.selectHeaderTitle != title) {
        this.selectHeaderTitle = title
        this.isUpperClick = true
      } else {
        this.isUpperClick = false
      }
      if (this.selectHeaderTitle == this.headerTitleList[0].title) {
        if (this.isUpperClick) {
          this.allDataList.sort((m1, m2) => {
            return m2.createTime - m1.createTime
          })
        } else {
          this.allDataList.sort((m1, m2) => {
            return m1.createTime - m2.createTime
          })
        }
      } else if (this.selectHeaderTitle == this.headerTitleList[2].title) {
        if (this.isUpperClick) {
          this.allDataList.sort((m1, m2) => {
            return m2.cost - m1.cost
          })
        } else {
          this.allDataList.sort((m1, m2) => {
            return m1.cost - m2.cost
          })
        }
      }
      if (!this.isUpperClick) {
        this.selectHeaderTitle = ""
      }
    },
    getCurrentTimeColor(title) {
      return this.curTimeRange.title == title ? '#3894ff' : '#565656'
    },
    getCurrentNameColor(name) {
      return this.curUserName == name ? '#3894ff' : '#565656'
    },
    selectUserNameCommand(index) {
      this.curUserName = this.userNameList[index];
      this.getResourceData();
    },
    selectTimeRangeCommand(index) {
      this.curTimeRange = this.timeRangeList[index];
      this.getResourceData();
    },
    currentDo(index) {
      this.currentPage = index;
    },
    createData() {
      this.pageSie = screen.availHeight <= 875 ? 5 : 10;
      this.currentPage = 1;
      this.allDataList = []
      this.getAllDataList();
    },
    async getResourceData() {
      let resourcesList = []
      this.loading = true
      try {
        const resourceObj = await queryResourcesList({type: this.resourceType, timeRange: this.curTimeRange}, false);
        resourcesList = resourceObj.resourcesList
      } catch (error) {
        this.loading = false
      }
      this.getPageData(resourcesList)
    },

    async getPageData(resourcesList) {
      const newList = []
      this.userNameList = []
      let totalCost = 0
      const href = window.location.origin
      for (const item of resourcesList) {
        const isHave = this.userNameList.some(name => {
          return name == item.owner
        })
        if (!isHave) {
          this.userNameList.push(item.owner)
        }
        const getSheetModel = async (item) => {
          let cost = 0
          const list = await getQueryMetricsBySheet(item.resourceid, false)
          for (const model of list) {
            if (item.committer == model.trialinfo?.committer) {
              const price = getCostValueByRun(model.trialinfo?.runnersList, model.trialinfo?.machinesensitive)
              cost += price
            }
          }
          totalCost += cost
          if (cost > 0) {
            const committer = item.committer
            const owner = item.owner
            const resourceId = item.resourceid;
            const trail = href + '/cost/triallist/' + item.resourceid;
            const createDate = moment(
              (item.creationtime?.seconds +
                item.creationtime?.nanos / Math.pow(10, 9)) * 1000
            ).format("YYYY-MM-DD HH:mm:ss");
            const createTime = item.creationtime?.seconds
            const model = {
              trail,
              committer,
              createDate,
              createTime,
              resourceId,
              owner,
              cost
            };
            newList.push(model);
          }
        }
        if (this.selectUserName) {
          const userId = this.$route.params?.userId
          if (this.selectUserName == item.owner && userId == item.committer) {
            await getSheetModel(item)
          }
        } else {
          await getSheetModel(item)
        }
      }
      this.loading = false
      this.originAllDataList = [...newList]
      this.allDataList = newList
      this.userNameList.push('None')
      this.totalPrice = Math.round(totalCost * 100) / 100
    },

    async getAllDataList() {
      this.headerTitle = (BenchMarkType.Sheet + ' list').toLocaleUpperCase();
      const title = BenchMarkType.Sheet
      document.title = `aqua.${title}list`
      this.getResourceData()
    },
  },
  created() {
    const userName = this.$route.params?.name
    if (userName) {
      this.curUserName = userName
    }
    const time = this.$route.params?.time
    const length = this.$route.params?.length
    if (time && length) {
      const list = TimeRangeDataList.filter(model => {
        return model.value == time && model.length == length
      })
      if (list?.length > 0) {
        this.curTimeRange = list[0]
      }
    }
    this.createData();
  },
};
</script>
<style lang='less' scoped>
.sheetCostListPage {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
}

.bg {
  padding: 35px 0px 10px 0px;
  background-color: #f5f5f5;
  max-width: 1800px;
  width: calc(100% - 60px);
  min-width: 900px;
  margin: 0 auto;
}

.content-box {
  padding: 35px 53px;
  position: relative;
  background-color: #ffffff;
  border-radius: 3px;
  position: relative;
}

.top-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .select-btn {
    width: 180px;
    height: 50px;
    color: #333;
    font-size: 15px;
    font-weight: 500;
  }
}

.table {
  width: 100%;
  border: 1px solid #999999;
  margin-top: 20px;
}

.header-title {
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000000;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
}

.trial-bg {
  display: flex;
  align-items: center;
  padding: 10px 0px 10px 5px;
  justify-content: center;

  .table-trial {
    display: flex;
    color: #0052d9;
    font-size: 14px;
    font-weight: 400;
    align-items: center;
    cursor: pointer;
  }
}

.table-other {
  color: #383838;
  font-size: 14px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: pre-wrap;
}

.page-cost {
  color: #333;
  font-size: 15px;
  display: flex;
  margin-top: 10px;
  padding-right: 10px;
  justify-content: flex-end;
  span {
    font-weight: 500;
    color: #0052d9;
  }
}

.page-bg {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  .page-left {
    color: #000000;
    font-size: 14px;
    font-weight: 400;
  }
  .page-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}

:deep(.el-table th) {
  user-select: initial !important;
}


.dropdown-list {
  max-height: 400px;
}
.el-dropdown-menu__item {
  width: 150px !important;
}
</style>